import connect from 'app/libs/connect';
import { getAppName } from 'app/router/selectors';

const withAppName = connect({ appName: getAppName });

export default withAppName;
